function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "f13081bddf"
}, React.createElement("path", {
  d: "M 20.910156 116.582031 L 788.910156 116.582031 L 788.910156 693 L 20.910156 693 Z M 20.910156 116.582031 ",
  clipRule: "nonzero"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#f13081bddf)"
}, React.createElement("path", {
  fill: "#ffffff",
  d: "M 764.910156 116.933594 L 44.910156 116.933594 C 31.660156 116.933594 20.910156 127.6875 20.910156 140.9375 L 20.910156 668.980469 C 20.910156 682.230469 31.660156 692.984375 44.910156 692.984375 L 764.910156 692.984375 C 778.15625 692.984375 788.910156 682.230469 788.910156 668.980469 L 788.910156 140.9375 C 788.910156 127.6875 778.15625 116.933594 764.910156 116.933594 Z M 404.910156 467.027344 L 102.847656 164.9375 L 706.972656 164.9375 Z M 274.972656 404.957031 L 68.910156 611.039062 L 68.910156 198.875 Z M 308.910156 438.898438 L 387.941406 517.9375 C 392.621094 522.617188 398.765625 524.96875 404.910156 524.96875 C 411.054688 524.96875 417.199219 522.617188 421.878906 517.9375 L 500.910156 438.898438 L 706.972656 644.980469 L 102.847656 644.980469 Z M 534.847656 404.957031 L 740.910156 198.875 L 740.910156 611.039062 Z M 534.847656 404.957031 ",
  fillOpacity: 1,
  fillRule: "nonzero"
}));

var SvgEmail = function SvgEmail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 1080,
    zoomAndPan: "magnify",
    viewBox: "0 0 810 809.999993",
    height: 1080,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgEmail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/email.f410d44d.svg";
export { ForwardRef as ReactComponent };